import { useParams } from 'react-router-dom';
import { useIsAdmin } from '@/hooks';
import useListAdminMicroApps from '@/hooks/admin/microApps/useListAdminMicroApps';
import useListOrganizationVisibleMicroApps from '@/hooks/microApps/useListOrganizationVisibleMicroApps';
import buildOrganizationAppPath from '@/pages/microApps/helpers/buildOrganizationAppPath';
import StaticCrumb from '../StaticCrumb';
import type { MicroAppCrumbProps } from './types';

const MicroAppCrumb = ({ isCurrentPage }: MicroAppCrumbProps) => {
    const { agentId = '', appSlug = '' } = useParams();
    const { isAdmin, isLoadingAdmin } = useIsAdmin();
    const { microApps } = useListAdminMicroApps({ isQueryEnabled: isAdmin });
    const { apps } = useListOrganizationVisibleMicroApps({
        organizationId: agentId,
        isQueryEnabled: !isLoadingAdmin && !isAdmin,
    });
    const definition = isAdmin
        ? microApps.find(microApp => microApp.slug === appSlug)
        : apps.find(microApp => microApp.slug === appSlug);

    return (
        <StaticCrumb
            label={definition ? definition.displayName : appSlug}
            href={buildOrganizationAppPath({ organizationId: agentId, appSlug })}
            isCurrentPage={isCurrentPage}
        />
    );
};

export default MicroAppCrumb;
